!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();
window.theme = window.theme || {};
theme.cacheSelectors = function () {
  theme.cache = {
    $w: $(window),
    $body: $('body'),
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),
    $productImage: $('#ProductPhotoImg'),
    $productImageGallery: $('.gallery__item'),
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',
    $hasDropdownItem: $('.site-nav--has-dropdown')
  }
};
timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};
theme.init = function () {
  theme.cacheSelectors();
  timber.cacheVariables();
  theme.mobileNav();
  theme.equalHeights();
  theme.cartPage();
  theme.toggleMenu();
  
    theme.productImageGallery();
  
};
theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });
  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
  });
};
theme.equalHeights = function () {
  theme.cache.$w.on('load', resizeElements());
  theme.cache.$w.on('resize',
    afterResize(function() {
      resizeElements();
    }, 250, 'equal-heights')
  );
  function resizeElements() {
    theme.cache.$productGridImages.css('height', 'auto').equalHeights();
    theme.cache.$featuredGridImages.css('height', 'auto').equalHeights();
  }
};
theme.productImageGallery = function() {
  if (!theme.cache.$productImageGallery.length) {
    return;
  };
  theme.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: true,
    tClose: 'Close (Esc)',
    removalDelay: 500,
    callbacks: {
      open: function(){
        $('html').css('overflow-y','hidden');
      },
      close: function(){
        $('html').css('overflow-y','');
      }
    },
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)'
    }
  });
  theme.cache.$productImage.bind('click', function() {
    var imageId = $(this).attr('data-image-id');
    theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });
};
theme.cartPage = function () {
  
  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
};
theme.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';
  theme.cache.$hasDropdownItem.on('click', function(evt) {
    var $el = $(this);
    if (!$el.hasClass(showDropdownClass) && timber.vars.isTouch) {
      evt.preventDefault();
      $el.addClass(showDropdownClass);
      $doc.on('click', handleClickOutsideDropdown);
    }
    function handleClickOutsideDropdown (evt) {
      var $target = $(evt.target);
      if (!$target.is($el) && !$.contains($el[0], $target[0])) {
        $el.removeClass(showDropdownClass);
        $doc.off('click', handleClickOutsideDropdown)
      }
    }
  })
};
$(".carousel").each(function(){
  $(this).owlCarousel({
    autoPlay: 7000,
    items : 4,
    itemsDesktop : [1199,4],
    itemsDesktopSmall : [1024,3],
    itemsTablet : [979, 2],
    itemsTabletSmall: [767, 2],
    itemsMobile: [479, 1],
    navigation: true,
    navigationText: ["<span class='owl-prev-img'>prev</span>","<span class='owl-next-img'>next</span>"]
  });
});
$(".carousel-4").each(function(){
  $(this).owlCarousel({
    autoPlay: 7000,
    items : 4,
    margin: 15,
    itemsDesktop : [1199,5],
    itemsDesktopSmall : [1024,4],
    itemsTablet : [979, 3],
    itemsTabletSmall: [767, 2],
    itemsMobile: [479, 1],
    navigation: true,
    navigationText: ["<span class='owl-prev-img'>prev</span>","<span class='owl-next-img'>next</span>"]
  });
});
$("#ProductThumbs").each(function(){
 $(this).bxSlider({
    mode: 'vertical',
    slideWidth: 400,
    minSlides: 4, 
    slideMargin: 10,
    pager: false,
    controls: true
  });
});
$(theme.init)
$(document).ready(function() {
  $('.show-sub-menu').click(function () {
    if($(this).hasClass('opened')) {
    	$(this).css("background-position" , "-60px -89px").removeClass('opened');		
    } else {			
      $(this).css("background-position" , "-44px -89px").addClass('opened');
    }
      $(this).parents('.sidebar-main-menu  ').children('.submenu').slideToggle("fast");
      return false;
  });
  $('.more').click(function () {
        $(this).hide();
  		$('.hide-first').slideDown();
  });
  $('#back-to-top').click(function () {
  		$("html, body").animate({
            scrollTop: 0
        }, 600);
  });
  $('#qty-plus').click(function () {
        var val = $('#quantity').val();
        var newVal = parseInt(val) + 1;
        var output = parseInt(newVal);
        $('#quantity').val(output);
  });
  $('#qty-minus').click(function () {
        var val = $('#quantity').val();
        var newVal = parseInt(val) - 1;
        var output = parseInt(newVal);
        $('#quantity').val(output);
  });
  $('.img-symbol').click(function () {
    if($(this).hasClass('opened')) {
      $(this).attr("src" , "https://cdn.shopify.com/s/files/1/1239/4342/t/6/assets/plus.png?4712324935789910717").removeClass('opened');		
    } else {			
      $(this).attr("src" , "https://cdn.shopify.com/s/files/1/1239/4342/t/6/assets/minus.png?13544927750485153360").addClass('opened');		
    }
    $('.toggle_content').slideToggle();
  });
  $('.designer-list-container li a').hover(function(e){
    e.preventDefault();
    var url = $(this).attr('href');
    var img = $(this).siblings('img').attr('src');
    $('.designer-banner-container a').attr('href',url);
    $('.designer-banner-container a img').attr('src',img);
    $('.blackbook_banner').attr('href' , url);
  });
});
$(document).scroll(function() {
    var y = $(this).scrollTop();
    if (y > 800) {
      $('#back-to-top').fadeIn();
    } else {
      $('#back-to-top').fadeOut();
    }
  var scroll = $(window).scrollTop();
  var banner_top = $('site-header').height();
  var header_height = $('.site-header').height();
  header_height = header_height + 40;
  if (scroll > header_height ) {
    $('.site-header').removeClass('is-absolute');
    $('.site-header .up-nav').addClass('is-fixed').addClass('mm-fixed-top');
    $('.site-header').css('background','white');
    $('.designer-banner-container').addClass('sticky-banner');
    $('.designer-banner-container').css('top',banner_top);
  }else{
    $('.site-header').addClass('is-absolute');
    $('.site-header .up-nav').removeClass('is-fixed').addClass('mm-fixed-top').removeClass('mm-fixed-top');
    $('.site-header').css('background','transparent');
    $('.designer-banner-container').removeClass('sticky-banner');
  }
  });
$('.toggle-sidebar').click(function(){
  $('.mobile-shop-sidebar').slideToggle();
  $('.mobile-main-menu').css('display', 'none');
  $('.toggle-sidebar').css('display','none');
  $('.toggle-menu').css('display','block');
});
$('.toggle-menu').click(function(){
  $('.mobile-main-menu').slideToggle();
  $('.mobile-shop-sidebar').css('display','none');
  $('.toggle-menu').css('display','none');
  $('.toggle-sidebar').css('display','block');
});
$(document).ready(function(){
  $(".selection-checkbox").click(function(){
    if($(this).is(':checked')){
      $(".custom-field-section").slideToggle();
      $("#productSelect").children("option").val($(this).val());
      var price= jQuery(this).attr('data-price');
      $('#ProductPrice').text( price );
    }
    if(!$(this).is(':checked')){
      $(".custom-field-section").css("display","none");
      $("#productSelect").children("option").val($(".selection-checkbox-no").val());
      var price= jQuery($('.selection-checkbox-no')).attr('data-price');
      $('#ProductPrice').text( price );
    }
  });
})
$(document).ready(function() {
 $(".shop .site-nav__dropdown > li:first-child").addClass("link-active");
  $(".shop .site-nav__dropdown li").on('mouseover', function() {
    $(".shop .site-nav__dropdown li").find('.third-level-menu').removeClass('link-active');
    $(this).find('.third-level-menu').addClass('link-active');  
    $(".nav_tag_item").css('display','none');
  });
});
$(document).ready(function() {
 $(".shop .site-nav__dropdown > li:first-child").addClass("active-link");
  $(".shop .site-nav__dropdown li").on('mouseover', function() {
    $(".shop .site-nav__dropdown > li:first-child").removeClass('active-link');
 $(".shop .site-nav__dropdown > li:first-child").find('.third-level-menu').css("display","none");
  });
   $(".shop .site-nav__dropdown > li:first-child").on('mouseover', function() {
 $(".shop .site-nav__dropdown > li:first-child").find('.third-level-menu').css("display","block");
         $(".nav_tag_item").css('display','block');
  });
});
  $(document).ready(function(){
    $(".buy-now").click(function(){
      var variant_id = $(this).attr("data-id");
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data:{ quantity:1,id:variant_id },
        success: function(res){
          window.location.href = "/checkout";
        }
    });  
  });
  });
  $(document).ready(function(){
    $(".hvr-dsply .product_add_to_cart").click(function(e) {
      e.preventDefault();
      var thisVar = $(this);
      var varientId = $(this).attr("data-attr");
      var pro_qty = 1 ;
var line1 = $(this).siblings().find('#monogram').val();
      var data = 'id='+ varientId + '&quantity='+pro_qty;
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { 
            quantity:1,
            id : varientId, 
            properties: { '_product1': line1 } 
          },
        success: function(res){ 
          $.getJSON('/cart.js', function(cart) {
            if($(window).width() > 767){
            $('.header-bar__cart-count').text('('+cart.item_count+') items in cart');
            }else{
            $('.header-bar__cart-count .mob-cart-count').text('('+cart.item_count+')');
            }
          });                
        }
      });      
      $(this).parents('.hvr-dsply').find('.success_msg').fadeIn(500);
          setTimeout(function(){ 
              $(".success_msg").fadeOut(300);
            }, 9000);     
    });
     $('.frmcart').hide();
    $.getJSON('/cart.js', function(cart) {                
       $.each(cart.items, function( index, value ) {			
         $(".add_"+value.id).hide();
         $(".remove_"+value.id).show();
       });        
            
    });   
    $(document).on("click", ".frmcart", function() {
      var elem = $(this);
      var variant_id = $(this).attr("data-id");     
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data:{ quantity:0,id:variant_id },
        success: function(res){
         elem.parent().parent().find('.frmcart').hide();
         elem.parent().parent().find('.buy-now-one').show();           
      		$.ajax({
              type: 'GET',
              url: '/cart.js',
              dataType: 'json',
              success: function(resData){
               var cartCount = resData.item_count;
                $(".header-bar__cart-count").html('<i class="fa fa-shopping-bag" aria-hidden="true"></i> (' + cartCount + ') item in bag');
              }
            });       
        }
    });
  });
      $(document).on("click", ".buy-now-one", function() {
      var elem = $(this);
      var variant_id = $(this).attr("data-id");
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data:{ quantity:1,id:variant_id },
        success: function(res){
        elem.parent().parent().find('.buy-now-one').hide();
        elem.parent().parent().find('.frmcart').show();    
      		$.ajax({
              type: 'GET',
              url: '/cart.js',
              dataType: 'json',
              success: function(resData){
               var cartCount = resData.item_count;
          		$(".header-bar__cart-count").html('<i class="fa fa-shopping-bag" aria-hidden="true"></i> (' + cartCount + ') item in bag');
              }
            });       
        }
    });
  });
    
    $('.acco-menu-mob').click(function(){
    $(this).toggleClass('open-active');
       $(this).parent().siblings('ul').slideToggle();
    })
    if($(window).width() < 768){
    $('.third-level-menu').hide();
    }
  });

